<template>
    <div class="associated-associatedHazards" v-if="associatedHazards.length > 0">
        <h2 class="t-orange text-center mb-3">Associated Hazards</h2>
        <div class="uxo-list columns is-multiline is-mobile mb-5">
            <template v-for="(associatedHazard) in associatedHazards">
                <div class="column is-4-mobile is-2-tablet mb-1">
                    <a class="uxo-list__item" :href="associatedHazard.url">
                        <img class="image mb-1" v-if="associatedHazard.images[0]" :src="associatedHazard.images[0].aws_url"
                             :alt="associatedHazard.name"/>
                        <h5 class="font-weight-normal">{{associatedHazard.name}}</h5>
                    </a>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    import {axiosApi} from "@/js/axios";
    import {ContentLoader} from 'vue-content-loader'

    export default {
        name: "CatUxoAssociatedHazards",
        props: {
            id: {
                type: Number,
                required: true
            }
        },
        data: function () {
            return {
                loading: true,
                associatedHazards: []
            }
        },
        computed: {},
        methods: {
            fetchAssociatedHazards() {
                return axiosApi.get(`/api/v3/hazards/related?id=${this.id}`)
                    .then(response => {
                        if (response.data.items) {
                            this.associatedHazards = response.data.items;
                        }

                        this.loading = false;
                    })
                    .catch(error => {
                        this.loading = false;
                    })
            },
        },
        created() {
            this.fetchAssociatedHazards();
        },
        mounted() {
        }
    }
</script>

<style scoped lang="scss">
    @include media-breakpoint-down(sm) {
        .column {
            padding: rem(8px);

            h5 {
                font-size: rem(16px);
            }
        }
    }

    @media (max-width: 560px) {
        .column.is-4-mobile {
            width: 50%;
        }
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/AssociatedHazards.vue